import { render, staticRenderFns } from "./PageParameters.vue?vue&type=template&id=1a1c7417&scoped=true"
import script from "./PageParameters.vue?vue&type=script&lang=js"
export * from "./PageParameters.vue?vue&type=script&lang=js"
import style0 from "./PageParameters.vue?vue&type=style&index=0&id=1a1c7417&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c7417",
  null
  
)

export default component.exports